(() => {
  // app/scripts/product-custom.js
  var form = document.querySelector(".popup-notification.main-product form");
  if (form) {
    const btnSubmit = form.querySelector('button[type="submit"]');
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      event.stopPropagation();
      btnSubmit?.classList.toggle("loading", true);
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      let formData = new FormData(form);
      const email = formData.get("email");
      const variantId = formData.get("variant-id");
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email
                }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      };
      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-06-15"
        },
        body: JSON.stringify(payload)
      };
      const popup = form.closest("popup-component");
      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UFZvec",
        requestOptions
      ).then((result) => {
        if (result.ok) {
          popup.querySelector(".res-noti .email-res").textContent = email;
          popup.querySelector(".res-noti").classList.toggle("hidden", false);
          form.classList.toggle("hidden-form", true);
          debounceTime(() => {
            popup.close();
          }, 3e3);
        }
      }).catch((error) => {
        console.error("error", error);
        popup.close();
      }).finally(() => {
        btnSubmit?.classList.toggle("loading", false);
      });
    });
  }
  function debounceTime(fn, wait = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
})();
